export default "/institutions/citi.svg";